export const BASE_URL = process.env.REACT_APP_BASE_URL;

export const BASIC_ROLE_GROUP = ['admin'];


// WEBPACK FOOTER //
// ./src/helpers/variables.js